var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mainConfig.showAuctionType)?_c('span',{staticClass:"ta-auction-type"},[_vm._v(" "+_vm._s(_vm._f("ucFirst")(_vm.auction.type))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }